<script lang="ts">
  /**
   * Shows all the location-results
   */
  import Translations from "../i18n/Translations"
  import SidebarUnit from "../Base/SidebarUnit.svelte"
  import Loading from "../Base/Loading.svelte"
  import { default as GeocodeResultSvelte } from "./GeocodeResult.svelte"
  import Tr from "../Base/Tr.svelte"
  import { ImmutableStore, Store, UIEventSource } from "../../Logic/UIEventSource"
  import type GeocodingProvider from "../../Logic/Search/GeocodingProvider"
  import type { GeocodeResult } from "../../Logic/Search/GeocodingProvider"
  import type { MapProperties } from "../../Models/MapProperties"
  import { ExclamationTriangle } from "@babeard/svelte-heroicons/solid/ExclamationTriangle"

  export let state: {
    searchState: {
      searchTerm: UIEventSource<string>
      suggestions: Store<GeocodeResult[]>
      suggestionsSearchRunning: Store<boolean>
      runningEngines: Store<string[]>
      failedEngines: Store<
        {
          source: GeocodingProvider
          error: any
        }[]
      >
    }
    featureSwitchIsTesting?: Store<boolean>
    userRelatedState?: { showTagsB: Store<boolean> }
    mapProperties: MapProperties
  }

  let searchTerm = state.searchState.searchTerm
  let results = state.searchState.suggestions
  let isSearching = state.searchState.suggestionsSearchRunning ?? new ImmutableStore(false)
  let runningEngines = state.searchState.runningEngines ?? new ImmutableStore([])
  let failedEngines = state.searchState.failedEngines

  let isTesting = state.featureSwitchIsTesting ?? new ImmutableStore(false)
  let showTags = state.userRelatedState?.showTagsB ?? new ImmutableStore(false)
  const t = Translations.t.general.search
</script>

{#if $searchTerm.length > 0}
  <SidebarUnit>
    <h3>
      <Tr t={t.locations} />
    </h3>

    {#if $results?.length > 0}
      {#each $results as entry (entry)}
        <GeocodeResultSvelte on:select {entry} {state} />
      {/each}
    {/if}

    {#if $isSearching}
      <div class="m-4 my-8 flex justify-center">
        <Loading>
          <Tr t={t.searching} />
          {#if $isTesting || $showTags}
            <div class="subtle">
              Querying {$runningEngines?.map((provider) => provider.name)?.join(", ")}
            </div>
          {/if}
        </Loading>
      </div>
    {/if}

    {#if !$isSearching && $results?.length === 0}
      <b class="flex justify-center p-4">
        <Tr t={t.nothingFor.Subs({ term: "<i>" + $searchTerm + "</i>" })} />
      </b>
    {/if}
    {#if $failedEngines?.length > 0}
      {#each $failedEngines as failed}
        <div class="warning flex flex-col items-center overflow-hidden py-4">
          <ExclamationTriangle class="w-4" />
          Search using {failed.source.name} failed
          <div class="subtle text-sm">
            {failed.error}
          </div>
        </div>
      {/each}
    {/if}
  </SidebarUnit>
{:else}
  <slot name="if-no-results" />
{/if}
